<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Customer"
        :baseView="baseView"
        :primaryLabel="model.Name"
        :secondaryLabel="baseView.id"
        recordType="Customer"
        v-if="loaded"
      />
    </template>

    <div class="css-v2 transaction-list customer-sample-requests">
      <div class="data-grid-details">
        <GcDataGrid
          :grouping="true"
          :export="true"
          :summary="true"
          :dataSourceConfig="
            screenJson.gridData
              ? screenJson.gridData.gridOptions.dataSource
              : undefined
          "
          :rowClick="rowClickCallBack"
          :columns="getColumns"
          :gridToolbar="
            screenJson.gridData ? screenJson.gridData.toolbar : undefined
          "
          :padColumn="true"
          :id="'transaction-list-grid'"
          v-if="loaded && screenJson.gridData"
          ref="transactionListGrid"
          :isEditableGrid="true"
          :showFooter="false"
          :gridOptions="
            screenJson.gridData ? screenJson.gridData.gridOptions : undefined
          "
          :elementAttrClass="'transaction-template'"
          :paging="true"
          :heightPadding="20"
        />
      </div>
    </div>
  </gc-main-layout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import CustomerTabsMixin from "@/_mixins/customer-tabs.mixin";
import DataGridMixin from "../../_mixins/data-grid.mixin";
import { CustomerService } from "../../_services/api/customers/customer.service";

import { CommonStorage, FeatureStorage } from "../../_services/storage";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";

export default {
  props: {
    /**
     * contains report configurations
     */
    reportConfig: {
      type: Object,
      default: undefined,
    },
  },
  mixins: [RouteMixin, CustomerTabsMixin, DataGridMixin],
  components: {},

  data() {
    return {
      persistenceKey: "customer-sample-request",
      backButtonRoute: `/customer`,
      CustomerSalesRepresentativeCode: undefined,
      model: {
        Code: "",
        Name: "",
      },

      gridOptions: {
        noDataMessage: {
          addNew: {
            class: "no-data",
            title: "No Sample Requests",
            message:
              "Currently there are no sample requests for this customer.",
          },
        },
      },
      loaded: false,
    };
  },
  computed: {
    screenJson() {
      var config = {
        title: "Customers",
        exportFileName: "Customers Sample Requests",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CustomerSampleRequestList",
              filter: [["CustomerCode", "=", this.baseView.id]],
              serverPaging: true,
              allowGrouping: false,
              // select: [],
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Sample Requests",
                message:
                  "Currently there are no sample requests for this customer.",
              },
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/sample-request/create",
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "SampleRequests",
                  "create"
                ),
                routeQuery: {
                  from: this.$route.path,
                  cus_id: this.baseView.id,
                },
              },
            ],
            filterOnEnter: true,
          },
        },
      };

      return config;
    },

    getColumns() {
      return [
        {
          screenField: "SampleRequest",
          label: "Request",
          type: "Integer",
          filterIndex: 0,
          width: ColumnWidth.SampleRequest.width,
          minWidth: ColumnWidth.SampleRequest.minWidth,
          sortOrder: "desc",
          sortIndex: 0,
          allowHiding: false,
          forceWidth: true,
        },
        {
          screenField: "DateCreated",
          label: "Date",
          filterLabel: "Date",
          filterIndex: 3,
          width: ColumnWidth.Date.width,
          maxWidth: ColumnWidth.Date.minWidth,
        },
        {
          screenField: "Customer",
          allowHiding: false,
          // filterIndex: 1,
        },
        {
          screenField: "CustomerContact",
          type: "Text",
          filterIndex: 2,
          width: ColumnWidth.CustomerContact.width,
          maxWidth: ColumnWidth.CustomerContact.minWidth,
          exportFields: undefined,
          cellTemplate: false,
          cellTemplateRecord: false,
        },
        {
          screenField: "Date",
          dataField: "DateChanged",
          label: "Last Update",
        },

        {
          screenField: "OrderStatus",
          dataField: "FriendlyStatus",
          filterDataField: "FriendlyStatus",
          filterIndex: 4,
          dataSourceConfig: {
            data: [
              "Cancelled",
              "Complete",
              "Notified",
              "Pending",
              "Prepared",
              "Sent",
            ],
          },
        },
      ];
    },
  },
  mounted() {},

  async created() {
    CommonStorage.clear("go_back_route");
    this.selectedIndex = this.tabs.findIndex((x) => x.text === "Sample Requests");

    await CustomerService.getByCode(this.baseView.id, ["Code", "Name"]).then(
      async (response) => {
        if (response.data.value.length > 0) {
          this.model.Code = response.data.value[0].Code;
          this.model.Name = response.data.value[0].Name;
        }
      }
    );

    this.loaded = true;
  },
  methods: {
    backButtonFunction() {
      this.$router.push({
        path: this.backButtonRoute,
      });
    },
    rowClickCallBack(e) {
      if (e.rowType == "data" && e.column.screenField != "OrderStatus") {
        this.onRowClicked(e, {
          view: this,
          page: "sample-request",
          mode: "review",
          idProperty: "SampleRequest",
          query: {
            from: this.$route.path,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss">
.customer-sample-requests {
  .gc-grid-item-container {
    margin: unset !important;
  }
}
</style>
